import React from 'react';
import classNames from 'classnames';
import css from './WhiteBox.module.css';

const WhiteBox = (props) => {
    const { children, className } = props;
    return <div className={classNames(css.root, className)}>
        {children}
    </div>
};

export default WhiteBox;
